// extracted by mini-css-extract-plugin
module.exports = {"rowText":"CampaignForm_rowText__1l2yp","createForm":"CampaignForm_createForm__13n9O","labelBold":"CampaignForm_labelBold__3dG73","socialWindow":"CampaignForm_socialWindow__29WnY"};